/*
 * Copyright 2024 Oddpods
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 *
 * See https://github.com/oddpods/cauce/blob/main/LICENSE
 */
package studio.oddpods.cauce.core.data.di

import org.koin.core.module.Module
import org.koin.dsl.module
import studio.oddpods.cauce.core.data.repository.TimeZoneMonitor
import studio.oddpods.cauce.core.data.repository.notification.NoOpNotificationScheduler
import studio.oddpods.cauce.core.data.repository.notification.NotificationScheduler

actual val platformModule: Module
    get() = module {
        single<TimeZoneMonitor> { TimeZoneMonitorImpl() }
        single<NotificationScheduler> { NoOpNotificationScheduler() }
    }
